var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "py-2 space-y-3 bg-white rounded-lg shadow-md px-8" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.isActivitiesLoaded,
            hasData: !!_vm.activitiesTimes,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "rounded-sm flex gap-2 w-96 h-10 font-outfit mt-6",
              attrs: { id: "filter-buttons" },
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "h-full w-1/2 border-gray-300 focus:outline-none font-normal text-lg hover:bg-hover-yellow hover:text-black rounded-full",
                  class: _vm.btnActive,
                  on: {
                    click: () => {
                      _vm.currentFilter = "active"
                    },
                  },
                },
                [
                  _vm._v(" Pending Approval "),
                  _c("span", { staticClass: "text-default-grey" }, [
                    _vm._v("(" + _vm._s(_vm.activeCount) + ")"),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "h-full w-1/2 focus:outline-none font-normal text-lg hover:bg-hover-yellow hover:text-black rounded-full",
                  class: _vm.btnCompleted,
                  on: {
                    click: () => {
                      _vm.currentFilter = "completed"
                    },
                  },
                },
                [
                  _vm._v(" Completed "),
                  _c("span", { staticClass: "text-default-grey" }, [
                    _vm._v("(" + _vm._s(_vm.completedCount) + ")"),
                  ]),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "mb-2 flex warning-text mb-4 w-full" }, [
            _c(
              "div",
              {
                staticClass: "ml-2 mt-1 h-4 w-auto notes-icon",
                attrs: { alt: "delete notes" },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("g", { attrs: { id: "Icon / InfoCircleFilled" } }, [
                      _c("path", {
                        attrs: {
                          id: "Vector",
                          d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                          fill: "#070823",
                        },
                      }),
                    ]),
                  ]
                ),
              ]
            ),
            _c("p", { staticClass: "child ml-2 text-sm" }, [
              _vm._v(
                " Just a quick heads-up: Logged hours directly mirror your resources' currently tracked hours. For the most up-to-date and accurate overview of logged hours, "
              ),
              _c("br"),
              _vm._v(
                " we recommend waiting until the weekly submission. You'll find the submitted hours in the Timesheets feature for your convenience. "
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass:
                "w-full bg-white pt-2 2xl:h-screen-1/2 lg:h-44 flex flex-col text-sm",
              attrs: { id: "table" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "w-full bg-[#1da1f2] rounded-t-sm font-outfit px-4 py-4 font-medium flex justify-between leading-6 space-x-2",
                  attrs: { id: "headings" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-3/12 text-sm relative font-medium font-outfit",
                    },
                    [_vm._v(" Visit Name ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-3/12 relative font-medium font-outfit border-l-1 pl-4",
                    },
                    [_vm._v(" Resource ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-3/12 flex items-center relative font-medium font-outfit border-l-1 pl-4",
                    },
                    [_vm._v(" Total Submitted Hours ")]
                  ),
                  _c("div", {
                    staticClass:
                      "w-1/12 flex items-center font-medium font-outfit text-right",
                  }),
                ]
              ),
              _vm.activitiesTimes && _vm.activitiesTimes.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-full rounded-b-sm pl-3 pr-1 h-2/3 overflow-y-scroll scrollbar",
                      attrs: { id: "body" },
                    },
                    [
                      _vm._l(_vm.activitiesTimes, function (activityTime) {
                        return _c(
                          "div",
                          {
                            key: activityTime.id,
                            staticClass:
                              "w-full rounded-b-sm h-13 flex border-b border-gray-300 justify-between space-x-2",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex items-center pl-4",
                                staticStyle: { width: "30%" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.activityDate(activityTime)) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "flex items-center pl-4",
                                staticStyle: { width: "30%" },
                              },
                              [
                                activityTime.contractor
                                  ? _c("SchedulerItemAvatar", {
                                      staticClass: "h-8 w-8",
                                      style: _vm.bgStyle(
                                        activityTime.contractor.user
                                      ),
                                      attrs: {
                                        avatar:
                                          activityTime.contractor.user.avatar,
                                        title: _vm.getContractorInitials(
                                          activityTime.contractor.user
                                        ),
                                        small: false,
                                      },
                                    })
                                  : _vm._e(),
                                activityTime.contractor
                                  ? _c("span", { staticClass: "ml-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          activityTime.contractor.user
                                            .given_name
                                        ) +
                                          " " +
                                          _vm._s(
                                            activityTime.contractor.user
                                              .family_name
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "flex items-center pl-4",
                                staticStyle: { width: "20%" },
                              },
                              [
                                activityTime.project_activity_times_aggregate
                                  .aggregate.sum.time
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.convertSecondsToReadable(
                                              activityTime
                                                .project_activity_times_aggregate
                                                .aggregate.sum.time
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.convertSecondsToReadable(0))
                                      ),
                                    ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center pr-5 justify-end",
                                staticStyle: { width: "20%" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "viewButton",
                                    on: {
                                      click: () => {
                                        _vm.selectedActivity = activityTime
                                        _vm.managementTimeTrackerModal = true
                                      },
                                    },
                                  },
                                  [_vm._v("View hours ")]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      _c("CardPagination", {
                        staticClass: "mt-4",
                        attrs: { config: _vm.paginationConfig },
                        on: {
                          "update:config": function ($event) {
                            _vm.paginationConfig = $event
                          },
                        },
                      }),
                    ],
                    2
                  )
                : _c("div", [
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-center h-44" },
                      [
                        _c("EmptyListPlaceholder", {
                          attrs: { title: "No logged hours" },
                        }),
                      ],
                      1
                    ),
                  ]),
            ]
          ),
          _vm.managementTimeTrackerModal
            ? _c("ManagementTimeTrackerModal", {
                attrs: { activity: _vm.selectedActivity },
                on: {
                  close: () => (_vm.managementTimeTrackerModal = false),
                  openDeclineReasonModal: (time) => {
                    _vm.selectedTime = time
                    _vm.managementTimeTrackerModal = false
                    _vm.showDeclineReasonModal = true
                  },
                },
              })
            : _vm._e(),
          _vm.showDeclineReasonModal
            ? _c("DeclineReasonModal", {
                staticClass: "z-100",
                attrs: { time: _vm.selectedTime },
                on: {
                  closeDeclineModal: () => {
                    _vm.showDeclineReasonModal = false
                    _vm.managementTimeTrackerModal = true
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }